import { render } from "./performanceStrategy.vue?vue&type=template&id=32ab6f6f&scoped=true"
import script from "./performanceStrategy.vue?vue&type=script&lang=js"
export * from "./performanceStrategy.vue?vue&type=script&lang=js"

import "./performanceStrategy.vue?vue&type=style&index=0&id=32ab6f6f&lang=scss&scoped=true"
import "./performanceStrategy.vue?vue&type=style&index=1&id=32ab6f6f&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ab6f6f"]])

export default __exports__